module.exports = __webpack_public_path__ + "assets/USDCoin(BSC).3406b4e0.svg";